import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Helmet from 'react-helmet';
import ButtonComponent from '../../common/ButtonComponent';
import { RequiresAuthenticatedUser } from '../../RequiresAuthenticatedUser';
import StepHeader from '../../../includes/StepHeader';
import OrderStore from '../../../stores/OrderStore';
import SvgIcon from '../../common/SvgIcon';
import AccountsStore from '../../../stores/AccountsStore';
import { getNavigationUrl } from '../../../actions/getNavigationUrl';
import OrderBL from './OrderBL';
import InternetBankingActions from '../../../actions/InternetBankingActions';
import LoaderComponent from '../../common/LoaderComponent';
import OrderActionCreator from '../../../actions/OrderActionCreator';
import ModalComponent from '../../common/modals/PatternLibModalComponent';
import { sayLandingMessage } from '../../../actions/AccessibilityActionCreator';
import { BioCatchContext } from '../../BioCatchContext';
import { DIGITAL_SERVICING_CONTEXT } from '../../../config/BioCatch';

class OrderComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: OrderBL.getOrderData(OrderStore.getOrderData(), this.props.content),
      type: OrderStore.getOrderData(),
      popupData: OrderStore.getPopupData(),
      popup: OrderStore.getPopupFlag(),
      pageStatus: OrderStore.getPageStatus(),
    };
    this.onStoreChange = this.onStoreChange.bind(this);
    this.backHandler = this.backHandler.bind(this);
    this.handleOrder = this.handleOrder.bind(this);
    this.hidePopup = this.hidePopup.bind(this);
    this.handlePopupOk = this.handlePopupOk.bind(this);
    this.getModal = this.getModal.bind(this);
    this.navigateToDigiStatements = this.navigateToDigiStatements.bind(this);
  }
  componentWillMount() {
    OrderActionCreator.hidePopup(false);
  }
  componentDidMount() {
    OrderStore.addChangeListener(this.onStoreChange);
    sayLandingMessage(this.state.data.helmetTitle);
  }
  componentWillUnmount() {
    OrderActionCreator.hidePopup(false);
    OrderStore.removeChangeListener(this.onStoreChange);
  }
  onStoreChange() {
    this.setState({
      data: OrderBL.getOrderData(
        OrderStore.getOrderData(),
        this.props.content,
        OrderStore.getBankId()
      ),
      type: OrderStore.getOrderData(),
      popupData: OrderStore.getPopupData(),
      popup: OrderStore.getPopupFlag(),
      pageStatus: OrderStore.getPageStatus(),
    });
  }
  getComponent() {
    const {
      type: { orderType },
    } = this.state;
    switch (this.state.pageStatus) {
      case 'page':
        let backflag = true;
        if (!_.isUndefined(this.state.data)) {
          return (
            <div
              className="container order-statement"
              id="site-main"
              role="main"
              tabIndex="-1"
            >
              <div className="row">
                <div className="col-sm1-24 col-md1-16 col-lg1-18">
                  <StepHeader
                    showheaderCrumbs={backflag}
                    onClick={this.backHandler}
                    headerCrumbsMessage="Back"
                    headerTitle={this.state.data.title}
                  />
                  <div>
                    <p>
                      {this.state.data.mainDescription}{' '}
                      {this.state.data.mainDescription2}
                    </p>
                  </div>
                  {this.calloutContent()}

                  <div className="order-statement__options">
                    <ButtonComponent
                      className="c-btn c-btn--secondary"
                      tabIndex=""
                      btnName={this.state.data.backButtonName}
                      onClick={this.backHandler}
                    />
                    {orderType !== 'orderStatement' && (
                      <ButtonComponent
                        className="c-btn c-btn--default"
                        tabIndex=""
                        btnName={this.state.data.orderButtonName}
                        onClick={this.handleOrder}
                      />
                    )}
                  </div>
                </div>
                {this.state.popup && this.getModal()}
              </div>
            </div>
          );
        }
        break;
      case 'loader':
        return <LoaderComponent type="large" />;
    }
  }
  getRenderComponent() {
    return (
      <div id="page" className="bow page order-component-page">
        <Helmet title={this.state.data.helmetTitle} />
        {/* <span id="accessH1ID" tabIndex="0" className="u-visually-hidden off-screen" ref="accessH1ID">You are on {this.state.data.helmetTitle} page</span> */}
        {this.getComponent()}
      </div>
    );
  }
  getModal() {
    let buttonName;
    let clickeventFunction;
    let modalBodyContent;
    let modalTitle = '';
    let customModalClass = 'c-modal c-modal--center';
    switch (String(this.state.popupData.status)) {
      case '200':
        buttonName = this.state.data.modelOkButton;
        clickeventFunction = this.handlePopupOk;
        modalBodyContent = this.state.data.modelBodyContent;
        modalTitle = (
          <div>
            <SvgIcon
              className="center-block account-success"
              id="icon-success"
              width="64px"
              height="64px"
            />
            <h4 className="c-modal__title modal-title">
              {this.state.data.modelTitle}
            </h4>
          </div>
        );
        break;
      case '500':
        buttonName = this.state.data.modelOkButton;
        clickeventFunction = this.hidePopup;
        modalBodyContent = this.state.popupData.error.error.message;
        customModalClass = 'c-modal';
        break;
    }
    let modalOKButton = (
      <ButtonComponent
        className="c-btn c-btn--default"
        tabIndex=""
        btnName={buttonName}
        onClick={clickeventFunction}
      />
    );
    return (
      <ModalComponent
        show={this.state.popup}
        onHide={this.hidePopup}
        customClass={customModalClass}
        modalHeading={modalTitle}
        modalBody={modalBodyContent}
        modalFooter={modalOKButton}
        bsSize="medium"
      />
    );
  }
  getLink(secondary, linkName, tertiary) {
    if (tertiary !== undefined) {
      if (
        AccountsStore.getAccountDetail(this.state.type.accountId)
          .actionsAvailable['/account/statements/read']
      ) {
        return (
          <p>
            <a
              href="javascript:void(0);"
              onClick={this.navigateToDigiStatements}
              className="order-statement__anchor"
            >
              {linkName}
            </a>
          </p>
        );
      }
    } else {
      if (
        AccountsStore.getAccountDetail(this.state.type.accountId)
          .actionsAvailable['/account/statements/read']
      ) {
        const index = linkName.indexOf(' $$');
        let linker1 = linkName.substr(0, index);
        const linker2 = linkName.substr(index + 1);
        let linker3 = linker2.replace('$$ ', '');
        return (
          <p>
            {secondary} {linker1}{' '}
            <a
              href="javascript:void(0);"
              onClick={this.navigateToDigiStatements}
              className="order-statement__anchor"
            >
              {linker3}
            </a>
            .
          </p>
        );
      } else {
        return <p>{secondary}</p>;
      }
    }
  }
  getCallOut(subtitle, main, secondary, tertiary, linkname, middleContent) {
    const navigateToHelp = () => {
      InternetBankingActions.navigateToWebTask('WEB-OPEN-HELP');
    };
    let component;
    let calloutClass;
    const { content } = this.props;
    if (secondary) {
      calloutClass = 'callout';
      component = (
        <div className="callout__wrapper">
          {main && <p>{main}</p>}
          {this.getLink(secondary, linkname, tertiary)}
          {middleContent && (
            <p className="callout__middleContent">
              {middleContent}
              <a href="javascript:void(0);" onClick={navigateToHelp}>
                {content.callUsText}
              </a>
              {content.subContent2}
            </p>
          )}
        </div>
      );
    } else {
      calloutClass = 'callout';
      component = (
        <div>
          {subtitle && <h3>{subtitle}</h3>}
          <p>{main}</p>
        </div>
      );
    }
    return <div className={calloutClass}>{component}</div>;
  }
  hidePopup() {
    this.setState({
      popup: false,
    });
  }
  handleOrder() {
    OrderActionCreator.sendOrderRequest({
      type: this.state.type.orderType,
      accountId: this.state.type.accountId,
    });
  }
  backHandler() {
    InternetBankingActions.navigateToWebTask(this.state.type.navigation);
    OrderActionCreator.hidePopup(false);
  }
  handlePopupOk() {
    this.backHandler();
    // OrderActionCreator.hidePopup(false);
    // this.hidePopup();
  }
  navigateToDigiStatements(e) {
    getNavigationUrl('WEB-ORDER-STATEMENT');
    InternetBankingActions.navigateToWebTask('WEB-DIGITAL-STATEMENTS');
    e.preventDefault();
  }
  calloutContent() {
    switch (this.state.type.orderType) {
      case 'orderStatement':
        return this.getCallOut(
          undefined,
          this.state.data.subDescription,
          true,
          true,
          this.state.data.linkName,
          this.state.data.middleContent
        );
      case 'orderCheque':
        return this.getCallOut(
          this.state.data.subTitle,
          this.state.data.subDescription,
          undefined,
          undefined,
          undefined,
          undefined
        );
      case 'orderPayin':
        return this.getCallOut(
          this.state.data.subTitle,
          this.state.data.subDescription,
          undefined,
          undefined,
          undefined,
          undefined
        );
    }
  }
  render() {
    return (
      <BioCatchContext context={DIGITAL_SERVICING_CONTEXT}>
        {this.getRenderComponent()}
      </BioCatchContext>
    );
  }
}
OrderComponent.propTypes = {
  content: PropTypes.object,
};
OrderComponent.defaultProps = {
  content: {},
};
export default RequiresAuthenticatedUser(OrderComponent);
